import {
  EvaluationCreateSchema,
  evaluationSchema,
} from "@/schema/console/regular-assessments/Evaluation";
import { z } from "zod";

export const questionSchema = z.object({
  id: z.number(),
  content: z.string(),
  points: z.number(),
  sdg_target_ids: z.array(z.number()),
  evaluations: z.array(evaluationSchema),
});

export const questionCreateSchema = questionSchema.omit({ id: true }).extend({
  evaluations: z.array(EvaluationCreateSchema),
});

export type QuestionCreate = z.infer<typeof questionCreateSchema>;
